'use client'

import { useEffect } from 'react'
import Link from 'next/link'

export default function NotFound() {
  useEffect(() => {
    // 404-Tracking und Weiterleitungs-Check
    const trackError = () => {
      const url = window.location.pathname
      const referer = document.referrer || ''
      const timestamp = new Date().toISOString()

      const data = JSON.stringify({
        url,
        referer,
        timestamp
      })

      // Fetch mit keepalive für zuverlässiges Tracking (auch bei Page Unload)
      // WICHTIG: Verwende NICHT sendBeacon(), da wir die Antwort brauchen um Weiterleitungen zu prüfen
      fetch('/api/404-tracker.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: data,
        keepalive: true // Request auch bei Seitenwechsel senden
      }).then(response => {
        // Prüfe ob Weiterleitung vorhanden ist
        if (response.ok) {
          return response.json()
        }
        return null
      }).then(result => {
        // Falls Weiterleitung existiert, leite um
        if (result && result.redirect && result.redirect.url) {
          window.location.href = result.redirect.url
        }
      }).catch(() => {
        // Fehler ignorieren (kein UI-Blocking)
      })
    }

    // Kleine Verzögerung um sicherzustellen dass Browser bereit ist
    const timer = setTimeout(trackError, 100)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <div className="mb-8">
          <div className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-orange-600">
            404
          </div>
        </div>

        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Seite nicht gefunden
        </h1>

        <p className="text-xl text-gray-600 mb-8">
          Die von Ihnen gesuchte Seite existiert leider nicht oder wurde verschoben.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            Zur Startseite
          </Link>

          <Link
            href="/kontakt"
            className="inline-flex items-center justify-center px-6 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-colors"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            Kontakt
          </Link>
        </div>

        <div className="mt-12 text-sm text-gray-500">
          <p>Wenn Sie glauben, dass dies ein Fehler ist, können Sie uns gerne kontaktieren.</p>
        </div>
      </div>
    </div>
  )
}
